import { ApiAdvancedFilter, PaginatedResponse } from '../../store/GeneralStore';
import { ProductMap, UnmappedProduct } from '../../store/ProductMap';
import { buildAdvancedQueryURL } from '../../utils/helpers';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const createProductMapData = (productMapData: ProductMap) => {
  return apiService.callExternalApi<ProductMap>({
    url: `${API_SERVER_URL}/product-maps`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: productMapData
  });
};

export const updateProductMapData = (productMapData: ProductMap) => {
  return apiService.callExternalApi<ProductMap>({
    url: `${API_SERVER_URL}/product-maps/${productMapData.id}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    data: productMapData
  });
};

export const deleteProductMapData = (id: string) => {
  return apiService.callExternalApi<ProductMap>({
    url: `${API_SERVER_URL}/product-maps/${id}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listProductMaps = (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'id', direction: 'desc' }]
  };

  return apiService.callExternalApi<PaginatedResponse<ProductMap>>({
    url: buildAdvancedQueryURL(mergedFilters, 'product-maps'),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listUnmappedProducts = (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'id', direction: 'desc' }]
  };

  return apiService.callExternalApi<PaginatedResponse<UnmappedProduct>>({
    url: buildAdvancedQueryURL(mergedFilters, 'product-maps/unmapped'),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listProductMapsByRpmAcctProductId = (id: string) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 1000,
    orders: [{ sort: 'id', direction: 'desc' }],
    filters: [{ field: 'rpmProductId', operator: 'equals', value: id }]
  };
  return apiService.callExternalApi<PaginatedResponse<ProductMap>>({
    url: buildAdvancedQueryURL(mergedFilters, 'product-maps'),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listProductMapsBySFDCProductId = (id: string) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 1000,
    orders: [{ sort: 'id', direction: 'desc' }],
    filters: [{ field: 'productSfId', operator: 'equals', value: id }]
  };
  return apiService.callExternalApi<PaginatedResponse<ProductMap>>({
    url: buildAdvancedQueryURL(mergedFilters, 'product-maps'),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
